import img from "../img/CWTA.webp";
import img1 from "../img/Flow.png";
import img2 from "../img/Payment.webp";
import img3 from "../img/Template.webp";
import img4 from "../img/Webview.webp"

const data = [
  {
    card_id: "1",
    section7: {
      card_image: img,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10B: {
      card_image: img,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10C: {
      card_image: img,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10D: {
      card_image: img,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10E: {
      card_image: img,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    benifits: {
      card_image: img,
      card_head1:
        "",
      card_head2:
        "Find quick answers about Vertex Suite WhatsApp Business Platform. Learn how automation works, what templates you can use.",
      
      benifits_list: [
        { title: "Seamless transition from ads to chat." },
        { title: "Social media ads redirect to WhatsApp." },
        { title: "Boost conversions with direct interaction." },
        { title: "Precise targeting for high ROAS." },
        { title: "Lead generation with WhatsApp chats." },
        { title: "Enhance customer journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
      ],
    },
  },

  {
    card_id: "1",
    section7: {
      card_image: img1,
      card_head1:
        " 2 Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10B: {
      card_image: img1,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10C: {
      card_image: img1,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10D: {
      card_image: img1,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10E: {
      card_image: img1,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    benifits: {
      card_image: img1,
      card_head1:
        "",
      card_head2:
        "Find quick answers about Vertex Suite WhatsApp Business Platform. Learn how automation works, what templates you can use.",
      
      benifits_list: [
        { title: "Seamless transition from ads to chat." },
        { title: "Social media ads redirect to WhatsApp." },
        { title: "Boost conversions with direct interaction." },
        { title: "Precise targeting for high ROAS." },
        { title: "Lead generation with WhatsApp chats." },
        { title: "Enhance customer journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
      ],
    },
  },

  {
    card_id: "1",
    section7: {
      card_image: img3,
      card_head1:
        " 3 Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10B: {
      card_image: img3,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10C: {
      card_image: img3,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10D: {
      card_image: img3,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10E: {
      card_image: img3,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    benifits: {
      card_image: img3,
      card_head1:
        "",
      card_head2:
        "Find quick answers about Vertex Suite WhatsApp Business Platform. Learn how automation works, what templates you can use.",
      
      benifits_list: [
        { title: "Seamless transition from ads to chat." },
        { title: "Social media ads redirect to WhatsApp." },
        { title: "Boost conversions with direct interaction." },
        { title: "Precise targeting for high ROAS." },
        { title: "Lead generation with WhatsApp chats." },
        { title: "Enhance customer journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
      ],
    },
  },

  {
    card_id: "1",
    section7: {
      card_image: img2,
      card_head1:
        " 4 Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10B: {
      card_image: img2,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10C: {
      card_image: img2,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10D: {
      card_image: img2,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10E: {
      card_image: img2,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    benifits: {
      card_image: img2,
      card_head1:
        "",
      card_head2:
        "Find quick answers about Vertex Suite WhatsApp Business Platform. Learn how automation works, what templates you can use.",
      
      benifits_list: [
        { title: "Seamless transition from ads to chat." },
        { title: "Social media ads redirect to WhatsApp." },
        { title: "Boost conversions with direct interaction." },
        { title: "Precise targeting for high ROAS." },
        { title: "Lead generation with WhatsApp chats." },
        { title: "Enhance customer journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
      ],
    },
  },

  {
    card_id: "1",
    section7: {
      card_image: img4,
      card_head1:
        "5 Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10B: {
      card_image: img4,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    section10C: {
      card_image: img4,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10D: {
      card_image: img4,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },
    section10E: {
      card_image: img4,
      card_head1:
        " Unlock digital success for your business with all-in-one SaaS solution!",
      card_head2:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
      card_head3:
        " Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite",
    },

    benifits: {
      card_image: img4,
      card_head1:
        "",
      card_head2:
        "Find quick answers about Vertex Suite WhatsApp Business Platform. Learn how automation works, what templates you can use.",
      
      benifits_list: [
        { title: "Seamless transition from ads to chat." },
        { title: "Social media ads redirect to WhatsApp." },
        { title: "Boost conversions with direct interaction." },
        { title: "Precise targeting for high ROAS." },
        { title: "Lead generation with WhatsApp chats." },
        { title: "Enhance customer journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
        { title: "Enhance journey through WhatsApp." },
      ],
    },
  },
];

export default data;
